<template>
  <div class="c--card-boxes_side-with-image display-grid grid-cols-1 grid-cols-md-10 gap-20 gap-md-30">
    <div
      :class="[
        'col-span-1 col-span-md-5',
        {
          'order-md-2 col-start-md-6': isReverse,
        },
      ]"
    >
      <nuxt-img
        :src="imageUrl"
        :alt="$t(title)"
        width="445"
        height="445"
        class="w-100 h-auto maxw-445"
        loading="lazy"
      />
    </div>
    <div
      :class="[
        'col-span-1 col-span-md-5 col-span-lg-4 display-flex flex-column justify-content-center align-items-start',
        {
          'col-start-lg-7': !isReverse,
          'col-start-md-1 order-md-1': isReverse,
        },
      ]"
    >
      <h2 class="typo-h3 typo-md-h1 mb-0">
        {{ $t(title) }}
      </h2>
      <template v-if="descriptionElement.length > 0">
        <div class="typo-p mt-10 color-text-secondary v-html-content" v-html="descriptionElement" />
      </template>
      <template v-if="$slots.default">
        <slot />
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      imageUrl: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      descriptionElement: {
        type: String,
        required: false,
        default: '',
      },
      isReverse: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
  }
</script>
